module.exports = __webpack_public_path__ + "img/1726043605475-screenshot-1726043586394.png.5991357c.webp";